import React from 'react';
import ChapterLayout from './ChapterLayout';
import { chapterTemplates } from '../../data/chapterTemplates';
import { leadership, alumni, gallery } from '../../data/uchicago';

const UChicago = () => (
  <ChapterLayout
    chapter={chapterTemplates.uchicago}
    leadership={leadership}
    alumni={alumni}
    gallery={gallery}
  />
);

export default UChicago;
